'use strict'

const promisify = require('promisify-es6')

module.exports = (send) => {
  return promisify((opts, callback) => {
    if (typeof (opts) === 'function') {
      callback = opts
      opts = {}
    }
    send({
      path: 'repo/gc',
      qs: opts
    }, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/repo/gc.js
// module id = 475
// module chunks = 0